@if (navbar.userAccess?.Mailbox=='Full' || navbar.userAccess?.Mailbox=='Readonly') {
@if (showLoader) {
<div class="loader text-center">
	<img src="../../../assets/img/loading.gif" />
</div>
}
<div class="row">
	<div class="col-12">
		<div class="card">
			<div class="card-body">
				<form [formGroup]="form">
					<app-mail-form formControlName="mail"></app-mail-form>
				</form>
				<app-file-uploader #fileUploaderComponent></app-file-uploader>
				<div class="mt-2">
					<button (click)="saveMail('compose_mail')" class="btn btn-xs btn-success me-1">
						<fa-icon [icon]="['fas', 'paper-plane']"></fa-icon>
						Send
					</button>
					<button class="btn btn-xs btn-success me-1" (click)="saveMail('create_draft')">
						<fa-icon [icon]="['fas', 'save']"></fa-icon>
						Save Draft
					</button>
				</div>
			</div>
		</div>
	</div>
</div>
}@else {
<div>
	<h3 class="text-center">You don't have access to this section.</h3>
</div>
}